import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-purple-600 to-purple-800 p-5">
      <div className="text-center text-white max-w-2xl">
        <h1 className="text-8xl font-bold mb-5 text-shadow-lg animate-pulse">404</h1>
        <h2 className="text-4xl md:text-5xl font-semibold mb-5">Page Not Found</h2>
        <p className="text-lg md:text-xl opacity-90 mb-10 leading-relaxed">
          Oops! The page you're looking for doesn't exist or has been moved.
        </p>
        <div className="flex flex-col sm:flex-row gap-5 justify-center items-center">
          <Link 
            to="/" 
            className="bg-white text-purple-600 px-8 py-4 rounded-full font-semibold hover:bg-gray-100 transform hover:-translate-y-1 transition-all duration-300 hover:shadow-xl uppercase tracking-wide"
          >
            Go Back Home
          </Link>
          <Link 
            to="/contact-us" 
            className="bg-transparent text-white border-2 border-white px-8 py-4 rounded-full font-semibold hover:bg-white hover:text-purple-600 transform hover:-translate-y-1 transition-all duration-300 hover:shadow-xl uppercase tracking-wide"
          >
            Contact Us
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
